import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { CheckoutModalComponent } from './checkout-modal/checkout-modal.component';
import { CheckoutListComponent } from './checkout-list/checkout-list.component';
import { CheckoutListCellComponent } from './checkout-list/checkout-list-cell.component';
import { CheckoutAcceptModalComponent } from './checkout-accept-modal/checkout-accept-modal.component';
import { CheckoutService } from './checkout.service';

import { NebularModule } from '../../common/modules/nebular/nebular.module';
import { FileUploaderComponent } from '../../common/components/file-uploader/file-uploader.component';
import { DatePickerFieldComponent } from '../../common/components/form/datepicker-field/datepicker-field.component';
import { InputFieldComponent } from '../../common/components/form/input-field/input-field.component';
import { PaginationComponent } from '../../common/components/pagination/pagination.component';
import { CardsService } from '../../common/services/card.service';

@NgModule({
  declarations: [
    CheckoutModalComponent,
    CheckoutListComponent,
    CheckoutAcceptModalComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    Ng2SmartTableModule,
    CheckoutListCellComponent,
    NebularModule,
    FileUploaderComponent,
    DatePickerFieldComponent,
    InputFieldComponent,
    PaginationComponent,
  ],
  exports: [
    CheckoutModalComponent,
    CheckoutListComponent,
    CheckoutAcceptModalComponent,
  ],
  providers: [CheckoutService, CardsService],
})
export class CheckoutModule {}
